export default __webpack_public_path__ + "static/media/Stage4_Locked.cc969fd0.svg";